import { render, staticRenderFns } from "./RelatieUnits.vue?vue&type=template&id=0ed905d0"
import script from "./RelatieUnits.vue?vue&type=script&lang=js"
export * from "./RelatieUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports